export default {"src":"/_next/static/media/eyeClose.967bc623.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};